import { Http, HttpCustomStructure } from 'app_utils/http';
import { store } from 'app_storage/redux-storage';
import { IPurchasedPlacesResponse } from 'app_types/purchasedItems/purchasedItemsTypes';
import { ScreenNotificationsUtil } from 'app_utils/screenNotification';


export interface IUserFormData {
  firstName: string;
  lastName: string;
  docNumber: string;
  docType: string;
  email: string;
  forceAssign?: boolean;
  forMyself?: boolean;
}

class PurchasedItemsService {
  private token: string;
  private storeObject: any;
  private Http: any;
  private screenNotification: ScreenNotificationsUtil;

  constructor() {
    this.Http = Http;
    this.storeObject = store;
    this.screenNotification = new ScreenNotificationsUtil();
    this.token = this.storeObject.getState().auth?.user?.token;
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth;
    this.token = (auth.user?.token) ? auth.user.token : '';
  }

  getPurchasedPlaces = async (): Promise<IPurchasedPlacesResponse> => {
    this.refreshAuthToken();

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: '/api/purchase-place/places',
      auth_token: this.token,
    };

    return await this.Http.send(queryData);
  }

  findUserByDocument = async (docNumber: string): Promise<any> => {
    this.refreshAuthToken();

    try {
      const queryData: HttpCustomStructure = {
        method: 'GET',
        url: `/api/purchase-place/find-user/${docNumber}`,
        auth_token: this.token
      };

      const response = await this.Http.send(queryData);
      return response;
    } catch (error) {
      console.error("Error finding user:", error);
      this.screenNotification.fire({
        status: 'error',
        message: 'Ha ocurrido un error al buscar el usuario. Por favor, intenta nuevamente.'
      });
      return null;
    }
  }

  assignPlace = async (placeId: string, userData: IUserFormData): Promise<any> => {
    this.refreshAuthToken();

    try {
      const queryData: HttpCustomStructure = {
        method: 'POST',
        url: `/api/purchase-place/assign/${placeId}`,
        auth_token: this.token,
        params: { userData }
      };

      const response = await this.Http.send(queryData);
      return response;
    } catch (error) {
      console.error("Error in assignPlace:", error);
      this.screenNotification.fire({
        status: 'error',
        message: 'Ha ocurrido un error al asignar el producto. Por favor, intenta nuevamente.'
      });
      return null;
    }
  }
}

export default PurchasedItemsService;